import { connect } from 'react-redux';
import WorkAreaInputButton from '../../components/Engineering/WorkAreaInputButton';
import { applyWorkArea, updateSketcher } from '../../actions/engineering';

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  let clickHandler;

  switch (ownProps.action) {
    case 'update-sketcher':
      clickHandler = (e) => {
        e.preventDefault();
        dispatch(updateSketcher(ownProps.params, ownProps.node));
      };
      break;
    case 'submit-work-area':
      clickHandler = (e) => {
        e.preventDefault();
        dispatch(applyWorkArea(ownProps.node, ownProps.params));
      };
      break;
    default:
      // no-op
      break;
  }

  return {
    ...ownProps,
    clickHandler,
  };
};

export default connect(null, null, mergeProps)(WorkAreaInputButton);
